import { pruneSalesPersons } from '@/lib/serializerUtils';

export default (record) => pruneSalesPersons(record);
